const currencySymbol = "€";

export { currencySymbol };
